const currencySymbol = "€";

export { currencySymbol };
